import PropTypes from 'prop-types';
import React from 'react';
import { FFTTooltipPointValueRow } from './FFTTooltipPointValueRow';
import { getMeasurementUnitSymbol } from 'helpers/unitHelper';
import { roundNumber } from 'helpers/numberHelper';
import './styles.scss';
import { formatDateTime, normalizeUtcTimestamp } from 'helpers/dateTimeFormatter';

const FFTTooltip = (props) => {
    const {
        points,
        frequencyUnitSymbol,
        magnitudeUnitSymbol,
        precision,
    } = props;

    const frequency = roundNumber(points?.[0]?.x, precision).toFixed(precision);
    const rpm = Math.floor(frequency) * 60;

    const uniqueTimestamps = Array.from(
        new Set(points?.map(point => point?.series?.userOptions?.timestamp).filter(Boolean))
    );

    return (
        <div className='custom-fft-tooltip'>
            <div className='t-header'>
                {`${rpm} ${getMeasurementUnitSymbol(14)}`}
                <br />
                {`${frequency} ${frequencyUnitSymbol}`}
            </div>
            <div className={`t-body ${uniqueTimestamps?.length > 4 ? 'legends-wrap' : ''}`}>
                {uniqueTimestamps.map((timestamp, index) => {
                    const matchingPoints = points.filter(
                        point => point?.series?.userOptions?.timestamp === timestamp
                    );
                    if (matchingPoints?.length) {
                        return (
                            <div className='timestamp-container' key={index}>
                                <span className='fft-timestamp'>
                                    {formatDateTime(normalizeUtcTimestamp(timestamp))}
                                </span>
                                {matchingPoints.map((point, kpiIndex) =>
                                    <div className='t-item' key={kpiIndex}>
                                        <FFTTooltipPointValueRow point={point} magnitudeUnitSymbol={magnitudeUnitSymbol} />
                                    </div>
                                )}
                                <div className='divider' />
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

FFTTooltip.propTypes = {
    points: PropTypes.array,
    frequencyUnitSymbol: PropTypes.string,
    magnitudeUnitSymbol: PropTypes.string,
    precision: PropTypes.number,
};

export default FFTTooltip;
